const validateEmail = (email) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    return emailRegex.test(email);
};

const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

const validateForm = async (state) => {
    let firstError;
    let validationSuccess = true;
    let validationMessage = {};

    if (!state.email) {
        validationMessage.email = "individualRegister.validation.email";
        if (!firstError) firstError = "email";
        validationSuccess = false;
        validationSuccess = false;
    } else {
        if (!validateEmail(state.email)) {
            validationMessage.email = "individualRegister.validation.emailInvalid";
            if (!firstError) firstError = "email";
            validationSuccess = false;
            validationSuccess = false;
        }
    }

    if (!state.password) {
        validationMessage.password = "individualRegister.validation.password";
        if (!firstError) firstError = "password";
        validationSuccess = false;
    } else if (state.password.length < 8) {
        validationMessage.password = "individualRegister.validation.passwordInvalid";
        if (!firstError) firstError = "password";
        validationSuccess = false;
    }

    if (state.password !== state.confirmPassword) {
        validationMessage.confirmPassword = "individualRegister.validation.password.confirmPassword";
        if (!firstError) firstError = "confirmPassword";
        validationSuccess = false;
    }

    // Section 2
    const countryWithoutPostCode = process.env.REACT_APP_COUNTRY_WITHOUT_POSTCODE;

    if (!countryWithoutPostCode.split(',').includes(state.billingCountryCode)) {
        if (!state.billingPostalCode) {
            validationMessage.billingPostalCode = "individualRegister.validation.billingPostalCode";
            if (!firstError) firstError = "billingPostalCode";
            validationSuccess = false;
        }
    }

    if (!state.billingCountry) {
        validationMessage.billingCountry = "individualRegister.validation.billingCountry";
        if (!firstError) firstError = "billingCountry";
        validationSuccess = false;
    }
    if (!state.billingName) {
        validationMessage.billingName = "individualRegister.validation.billingName";
        if (!firstError) firstError = "billingName";
        validationSuccess = false;
    } else if (state.billingName.length < 3) {
        validationMessage.billingName = "individualRegister.validation.billingNameMinLength";
        if (!firstError) firstError = "billingName";
        validationSuccess = false;
    }
    if (!state.billingPhoneNumber) {
        validationMessage.billingPhoneNumber = "individualRegister.validation.billingPhoneNumber";
        if (!firstError) firstError = "billingPhoneNumber";
        validationSuccess = false;
    }
    if (!state.billingAddress) {
        validationMessage.billingAddress = "individualRegister.validation.billingAddress";
        if (!firstError) firstError = "billingAddress";
        validationSuccess = false;
    }

    // Section 7 (TNC)
    if (!state.tnc) {
        validationMessage.tnc = "individualRegister.validation.tnc";
        if (!firstError) firstError = "tnc";
        validationSuccess = false;
    }

    return { validationSuccess, firstError, validationMessage };
};

export { validateForm, validateEmail, isValidEmail };